const enum CustomFieldTypes {
    STRING= 'string',
    LONG_TEXT= 'longtext',
    NUMBER= 'number',
    LINK= 'link',
    SELECT= 'select',
    CHECKBOX= 'checkbox'
}

export {
    CustomFieldTypes
}